import * as angular from "angular";
import {IQService} from "angular";
import {ConfirmDialogService} from "../../commons/services/confirm-dialog.service";
import * as _ from "lodash";
import {AccountModel} from "../../account/angular/models/account.model";
import {BatchRequestsService} from "../../batch/services/batch-requests.service";
import {OrderPlanningAlertsService} from "./order-planning-alerts.service";

export class OrderPlanningConfigurationDialogsService {

  constructor(private $mdDialog, private batchRequestsService: BatchRequestsService, private orderPlanningAlertsService: OrderPlanningAlertsService) {
  }

  // ******************************
  // External methods
  // ******************************

  uploadOrders(event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/upload-orders.html').default,
      targetEvent: event,
      clickOutsideToClose: false,
      fullscreen: true,
      controller: function ($scope) {

        $scope.cancel = self.$mdDialog.cancel;

        $scope.onChangeConfiguration = (configuration) => {
          $scope.configurationId = configuration.id;
        }

        $scope.onAddFile = (file) => {
          $scope.file = file;
        }

        $scope.onUpload = () => {
          if ($scope.file) {
            $scope.loading = true;

            self.batchRequestsService.importCustomDailyOrders($scope.file, $scope.configurationId)
              .then((res) => {

                if (res.responseCode === 'FAILED') {
                  $scope.rowsVerifications = res.rowsVerifications;
                  self.orderPlanningAlertsService.uploadCustomOrdersError();
                } else if (res.responseCode === 'OK' && !!res.rowsVerifications?.length) {
                  $scope.rowsVerifications = res.rowsVerifications;
                  self.orderPlanningAlertsService.uploadCustomOrdersWarning();
                } else {
                  self.orderPlanningAlertsService.uploadCustomOrdersSuccess();
                  self.$mdDialog.hide(res);
                }
              })
              .catch((error) => {
                self.orderPlanningAlertsService.uploadCustomOrdersError();
              })
              .finally(() => {
                $scope.loading = false;
              })
          }
        }

        $scope.onReupload = () => {
          $scope.file = undefined;
          $scope.rowsVerifications = undefined;
        }
      }
    })
  }

}

angular
  .module('bringoz.admin.order-planning-configuration')
  .service('orderPlanningConfigurationDialogsService', OrderPlanningConfigurationDialogsService);
